module.exports = __webpack_public_path__ + "h5/img/master_15.0f397e9b.jpg";